module.exports = __webpack_public_path__ + "static/media/above_the_trees_exhibition.4a197487.svg";